import { cn } from '@/lib/utils'

type Props = {
  children: React.ReactNode
  className?: string
  title?: string
}
export const VietDevilsContainer: React.FC<Props> = ({
  children,
  className,
  title,
  ...props
}) => {
  return (
    <section className={cn('px-4 py-10 lg:px-15', className)} {...props}>
      {title && (
        <h2 className='mb-1.5 font-sans text-xl font-medium leading-6.5'>
          {title}
        </h2>
      )}
      {children}
    </section>
  )
}
